import { featuredMovies } from '@/mocks/siteData';
import MovieCard from '@/components/feature/MovieCard';

export default function FeaturedSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
              精选推荐
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">为您精心挑选的优质内容</p>
          </div>
          <a href="#featured" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line ml-1" />
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              category={movie.category}
              rating={movie.rating}
              imageUrl={movie.imageUrl}
              tags={movie.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}